export const AMPLITUDE_EVENT_NAMES = {
    NEW_APPLICATION_MODAL_VIEWED: 'New application modal viewed',
    NEW_APPLICATION_MODAL_CLOSED: 'New application modal closed',
    NEW_APPLICATION_MODAL_SUBMITTED: 'New application modal submitted '
};
